export const DEFAULT_REPORT_TIMER_IN_MINUTES = 10

export function getReportTimerMinutesWithFallback(timerInMinutes, fallbackTimerInMinutes = DEFAULT_REPORT_TIMER_IN_MINUTES) {
  const parsedTimerInMinutes = Number(timerInMinutes)

  if (!parsedTimerInMinutes || parsedTimerInMinutes <= 0) {
    return fallbackTimerInMinutes
  }

  return parsedTimerInMinutes
}

export function getReportTimerDurationInMillisecondsWithFallback(timerInMinutes) {
  return getReportTimerMinutesWithFallback(timerInMinutes) * 60 * 1000
}

export function getReportTimerExpirationTimeWithFallback(referenceTime, timerInMinutes) {
  const durationInMilliseconds = getReportTimerDurationInMillisecondsWithFallback(timerInMinutes)
  const parsedReferenceTime = referenceTime instanceof Date ? new Date(referenceTime.getTime()) : new Date(referenceTime)

  return new Date(parsedReferenceTime.getTime() + durationInMilliseconds)
}
